// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-specific styles for Le Saverdunois */

/* Navigation styles */
.nav-link {
    font-family: IBM Plex Sans, system-ui, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-text) / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.nav-link:hover {
    --tw-text-opacity: 1;
    color: rgb(var(--sd-primary) / var(--tw-text-opacity, 1));
}

.nav-link.active {
    --tw-text-opacity: 1;
    color: rgb(var(--sd-primary) / var(--tw-text-opacity, 1));
}

/* Editorial grid borders */
.editorial-border-r {
    border-right-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-border) / var(--tw-border-opacity, 1));
}

.editorial-border-b {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-border) / var(--tw-border-opacity, 1));
}

.editorial-border-t {
    border-top-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-border) / var(--tw-border-opacity, 1));
}

/* Article card hover */
.article-card {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
    animation-duration: 300ms;
}

.article-card:hover {
    background-color: rgb(var(--sd-accent) / 0.3);
}

.article-card:hover .article-title {
    --tw-text-opacity: 1;
    color: rgb(var(--sd-primary) / var(--tw-text-opacity, 1));
}

.article-card .article-image {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 500ms;
    animation-duration: 500ms;
}

.article-card:hover .article-image {
    --tw-scale-x: 1.05;
    --tw-scale-y: 1.05;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

/* Category badges */
.category-badge {
    font-family: IBM Plex Mono, monospace;
    font-size: 0.75rem;
    line-height: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-primary) / var(--tw-text-opacity, 1));
}

/* Button styles */
.btn-primary {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-primary) / var(--tw-bg-opacity, 1));
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-family: IBM Plex Sans, system-ui, sans-serif;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.btn-primary:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-primary-hover) / var(--tw-bg-opacity, 1));
}

.btn-secondary {
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-text) / var(--tw-border-opacity, 1));
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-text) / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

.btn-secondary:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-inverse) / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* Newsletter section */
.newsletter-section {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-inverse) / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* Calendar event item */
.event-item {
    border-left-width: 4px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-primary) / var(--tw-border-opacity, 1));
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
}

/* Admin panel styles */
.admin-sidebar {
    min-height: 100vh;
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-inverse) / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.admin-nav-item {
    cursor: pointer;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

.admin-nav-item:hover {
    background-color: rgb(255 255 255 / 0.1);
}

.admin-nav-item.active {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-primary) / var(--tw-bg-opacity, 1));
}

/* Form styles */
.form-input {
    width: 100%;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-border) / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-surface) / var(--tw-bg-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-family: IBM Plex Sans, system-ui, sans-serif;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-text) / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.form-input:focus {
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-primary) / var(--tw-border-opacity, 1));
    outline: 2px solid transparent;
    outline-offset: 2px;
}

.form-textarea {
    width: 100%;
    resize: none;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-border) / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-surface) / var(--tw-bg-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-family: IBM Plex Sans, system-ui, sans-serif;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-text) / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

.form-textarea:focus {
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-primary) / var(--tw-border-opacity, 1));
    outline: 2px solid transparent;
    outline-offset: 2px;
}

.form-label {
    margin-bottom: 0.5rem;
    display: block;
    font-family: IBM Plex Sans, system-ui, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-text) / var(--tw-text-opacity, 1));
}

/* Page header */
.page-header {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(var(--sd-border) / var(--tw-border-opacity, 1));
    padding-top: 3rem;
    padding-bottom: 3rem;
}

.page-title {
    font-family: Cormorant Garamond, Georgia, serif;
    font-size: 2.25rem;
    line-height: 2.5rem;
    letter-spacing: -0.025em;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-text) / var(--tw-text-opacity, 1));
}

@media (min-width: 640px) {
    .page-title {
        font-size: 3rem;
        line-height: 1;
    }
}

/* Section styles */
.section-title {
    margin-bottom: 1.5rem;
    font-family: Cormorant Garamond, Georgia, serif;
    font-size: 1.5rem;
    line-height: 2rem;
    letter-spacing: -0.025em;
    --tw-text-opacity: 1;
    color: rgb(var(--sd-text) / var(--tw-text-opacity, 1));
}
@media (min-width: 640px) {
    .section-title {
        font-size: 1.875rem;
        line-height: 2.25rem;
    }
}

/* Mobile menu */
.mobile-menu {
    position: fixed;
    inset: 0px;
    z-index: 50;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-background) / var(--tw-bg-opacity, 1));
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
    animation-duration: 300ms;
}

.mobile-menu.closed {
    --tw-translate-x: -100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.mobile-menu.open {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

/* Loading skeleton */
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
.skeleton {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --tw-bg-opacity: 1;
    background-color: rgb(var(--sd-border) / var(--tw-bg-opacity, 1));
}

/* Toast customization */
[data-sonner-toaster] {
    --normal-bg: #111111;
    --normal-text: #ffffff;
    --success-bg: #111111;
    --success-text: #ffffff;
    --error-bg: #D92D20;
    --error-text: #ffffff;
}

/* ===================== RICH TEXT EDITOR ===================== */

.rich-editor-wrapper {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

.rich-editor-wrapper:focus-within {
    box-shadow: 0 0 0 2px rgba(217, 45, 32, 0.25);
}

.rich-editor-toolbar {
    background: #f8f8f7;
    border-bottom: 1px solid #e8e4dc;
    padding: 8px 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 2px;
    position: sticky;
    top: 0;
    z-index: 10;
}

.rich-editor-content {
    min-height: 300px;
    max-height: 600px;
    overflow-y: auto;
    padding: 20px 24px;
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 1rem;
    line-height: 1.75;
    color: #1a1a1a;
    background: #fff;
    outline: none;
    caret-color: #D92D20;
}

.rich-editor-content::-webkit-scrollbar { width: 6px; }
.rich-editor-content::-webkit-scrollbar-track { background: #f1f1f1; }
.rich-editor-content::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }

.rich-editor-content h1 { font-family: Georgia, serif; font-size: 2em; font-weight: bold; margin: 0.5em 0; }
.rich-editor-content h2 { font-family: Georgia, serif; font-size: 1.6em; font-weight: bold; margin: 0.5em 0; }
.rich-editor-content h3 { font-family: Georgia, serif; font-size: 1.3em; font-weight: bold; margin: 0.5em 0; }
.rich-editor-content p  { margin: 0.5em 0; }
.rich-editor-content ul { list-style: disc; padding-left: 1.8em; margin: 0.5em 0; }
.rich-editor-content ol { list-style: decimal; padding-left: 1.8em; margin: 0.5em 0; }
.rich-editor-content li { margin: 0.25em 0; }
.rich-editor-content blockquote { border-left: 4px solid #D92D20; margin: 1em 0; padding: 0.5em 1em; background: #fdf6f0; font-style: italic; color: #555; }
.rich-editor-content a { color: #D92D20; text-decoration: underline; }
.rich-editor-content img { max-width: 100%; height: auto; margin: 8px 0; display: block; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.12); }
.rich-editor-content hr { border: none; border-top: 2px solid #e8e4dc; margin: 1.5em 0; }
.rich-editor-content strong, .rich-editor-content b { font-weight: bold; }
.rich-editor-content em, .rich-editor-content i { font-style: italic; }
.rich-editor-content u { text-decoration: underline; }
.rich-editor-content s { text-decoration: line-through; }

/* ===================== ARTICLE RICH CONTENT DISPLAY ===================== */

.article-rich-content h1 {
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 2.2em;
    font-weight: bold;
    line-height: 1.2;
    margin: 1.2em 0 0.5em;
    color: #1a1a1a;
}

.article-rich-content h2 {
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 1.7em;
    font-weight: bold;
    line-height: 1.3;
    margin: 1.1em 0 0.5em;
    color: #1a1a1a;
    border-bottom: 2px solid #e8e4dc;
    padding-bottom: 0.3em;
}

.article-rich-content h3 {
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 1.3em;
    font-weight: bold;
    margin: 1em 0 0.4em;
    color: #2a2a2a;
}

.article-rich-content p {
    margin: 0.9em 0;
    line-height: 1.85;
}

.article-rich-content ul {
    list-style: disc;
    padding-left: 2em;
    margin: 0.8em 0;
}

.article-rich-content ol {
    list-style: decimal;
    padding-left: 2em;
    margin: 0.8em 0;
}

.article-rich-content li {
    margin: 0.35em 0;
    line-height: 1.7;
}

.article-rich-content blockquote {
    border-left: 4px solid #D92D20;
    margin: 1.5em 0;
    padding: 1em 1.5em;
    background: #fdf6f0;
    font-style: italic;
    color: #555;
    border-radius: 0 6px 6px 0;
    font-size: 1.08em;
}

.article-rich-content a {
    color: #D92D20;
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: color 0.2s;
}
.article-rich-content a:hover { color: #b02318; }

.article-rich-content img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 1.5em auto;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.14);
}

.article-rich-content hr {
    border: none;
    border-top: 2px solid #e8e4dc;
    margin: 2em 0;
}

.article-rich-content strong,
.article-rich-content b { font-weight: bold; }

.article-rich-content em,
.article-rich-content i { font-style: italic; }

.article-rich-content u { text-decoration: underline; text-underline-offset: 2px; }

.article-rich-content s { text-decoration: line-through; }

.article-rich-content pre,
.article-rich-content code {
    background: #f4f4f0;
    border-radius: 4px;
    padding: 0.2em 0.4em;
    font-family: monospace;
    font-size: 0.9em;
}

/* ===================== DARK MODE OVERRIDES (rich content) ===================== */

.dark .rich-editor-toolbar {
    background: #232019;
    border-bottom-color: #3a362f;
}

.dark .rich-editor-content {
    color: #f2ede6;
    background: #201d19;
}

.dark .rich-editor-content::-webkit-scrollbar-track { background: #2a2620; }
.dark .rich-editor-content::-webkit-scrollbar-thumb { background: #4a453c; }

.dark .rich-editor-content blockquote,
.dark .article-rich-content blockquote {
    background: #2a221c;
    color: #c9c2b6;
}

.dark .rich-editor-content hr,
.dark .article-rich-content hr {
    border-top-color: #3a362f;
}

.dark .article-rich-content h1,
.dark .article-rich-content h2,
.dark .article-rich-content h3 {
    color: #f2ede6;
}

.dark .article-rich-content h2 {
    border-bottom-color: #3a362f;
}

.dark .rich-editor-content pre,
.dark .article-rich-content pre,
.dark .article-rich-content code {
    background: #2a2620;
    color: #f2ede6;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,sBAAsB;AAElB;IAAA,iDAA6H;IAA7H,mBAA6H;IAA7H,oBAA6H;IAA7H,gBAA6H;IAA7H,yBAA6H;IAA7H,uBAA6H;IAA7H,oBAA6H;IAA7H,sDAA6H;IAA7H,+FAA6H;IAA7H,wDAA6H;IAA7H;AAA6H;AAA7H;IAAA,oBAA6H;IAA7H;AAA6H;;AAI7H;IAAA,oBAA4B;IAA5B;AAA4B;;AAGhC,2BAA2B;AAEvB;IAAA,uBAAsC;IAAtC,sBAAsC;IAAtC;AAAsC;;AAItC;IAAA,wBAAsC;IAAtC,sBAAsC;IAAtC;AAAsC;;AAItC;IAAA,qBAAsC;IAAtC,sBAAsC;IAAtC;AAAsC;;AAG1C,uBAAuB;AAEnB;IAAA,wBAAkC;IAAlC,wDAAkC;IAAlC,0BAAkC;IAAlC;AAAkC;;AAIlC;IAAA;AAA4B;;AAI5B;IAAA,oBAA4B;IAA5B;AAA4B;;AAI5B;IAAA,8BAAwC;IAAxC,wDAAwC;IAAxC,0BAAwC;IAAxC;AAAwC;;AAIxC;IAAA,kBAAgB;IAAhB,kBAAgB;IAAhB;AAAgB;;AAGpB,oBAAoB;AAEhB;IAAA,qCAAyE;IAAzE,kBAAyE;IAAzE,iBAAyE;IAAzE,yBAAyE;IAAzE,qBAAyE;IAAzE,oBAAyE;IAAzE;AAAyE;;AAG7E,kBAAkB;AAEd;IAAA,kBAAuH;IAAvH,kEAAuH;IAAvH,oBAAuH;IAAvH,qBAAuH;IAAvH,oBAAuH;IAAvH,uBAAuH;IAAvH,iDAAuH;IAAvH,gBAAuH;IAAvH,oBAAuH;IAAvH,mDAAuH;IAAvH,+FAAuH;IAAvH,wDAAuH;IAAvH;AAAuH;AAAvH;IAAA,kBAAuH;IAAvH;AAAuH;;AAIvH;IAAA,iBAA4H;IAA5H,sBAA4H;IAA5H,+DAA4H;IAA5H,oBAA4H;IAA5H,qBAA4H;IAA5H,oBAA4H;IAA5H,uBAA4H;IAA5H,oBAA4H;IAA5H,sDAA4H;IAA5H,+FAA4H;IAA5H,wDAA4H;IAA5H;AAA4H;;AAA5H;IAAA,kBAA4H;IAA5H,kEAA4H;IAA5H,oBAA4H;IAA5H;AAA4H;;AAGhI,uBAAuB;AAEnB;IAAA,kBAAqC;IAArC,kEAAqC;IAArC,oBAAqC;IAArC;AAAqC;;AAGzC,wBAAwB;AAEpB;IAAA,sBAAmD;IAAnD,sBAAmD;IAAnD,kEAAmD;IAAnD,mBAAmD;IAAnD,sBAAmD;IAAnD;AAAmD;;AAGvD,uBAAuB;AAEnB;IAAA,iBAAkD;IAAlD,kBAAkD;IAAlD,kEAAkD;IAAlD,oBAAkD;IAAlD;AAAkD;;AAIlD;IAAA,eAAmE;IAAnE,kBAAmE;IAAnE,mBAAmE;IAAnE,oBAAmE;IAAnE,uBAAmE;IAAnE,+FAAmE;IAAnE,wDAAmE;IAAnE;AAAmE;;AAAnE;IAAA;AAAmE;;AAInE;IAAA,kBAA0B;IAA1B;AAA0B;;AAG9B,gBAAgB;AAEZ;IAAA,WAAyK;IAAzK,iBAAyK;IAAzK,sBAAyK;IAAzK,iEAAyK;IAAzK,kBAAyK;IAAzK,kEAAyK;IAAzK,kBAAyK;IAAzK,mBAAyK;IAAzK,oBAAyK;IAAzK,uBAAyK;IAAzK,iDAAyK;IAAzK,oBAAyK;IAAzK,sDAAyK;IAAzK,+FAAyK;IAAzK,wDAAyK;IAAzK;AAAyK;AAAzK;IAAA,sBAAyK;IAAzK,kEAAyK;IAAzK,8BAAyK;IAAzK;AAAyK;;AAIzK;IAAA,WAAqL;IAArL,YAAqL;IAArL,iBAAqL;IAArL,sBAAqL;IAArL,iEAAqL;IAArL,kBAAqL;IAArL,kEAAqL;IAArL,kBAAqL;IAArL,mBAAqL;IAArL,oBAAqL;IAArL,uBAAqL;IAArL,iDAAqL;IAArL,oBAAqL;IAArL,sDAAqL;IAArL,+FAAqL;IAArL,wDAAqL;IAArL;AAAqL;;AAArL;IAAA,sBAAqL;IAArL,kEAAqL;IAArL,8BAAqL;IAArL;AAAqL;;AAIrL;IAAA,qBAAkE;IAAlE,cAAkE;IAAlE,iDAAkE;IAAlE,mBAAkE;IAAlE,oBAAkE;IAAlE,gBAAkE;IAAlE,oBAAkE;IAAlE;AAAkE;;AAGtE,gBAAgB;AAEZ;IAAA,wBAA4C;IAA5C,sBAA4C;IAA5C,iEAA4C;IAA5C,iBAA4C;IAA5C;AAA4C;;AAI5C;IAAA,+CAAwE;IAAxE,kBAAwE;IAAxE,mBAAwE;IAAxE,wBAAwE;IAAxE,oBAAwE;IAAxE;AAAwE;;AAAxE;IAAA;QAAA,eAAwE;QAAxE;IAAwE;AAAA;;AAG5E,mBAAmB;AAEf;IAAA,qBAA6E;IAA7E,+CAA6E;IAA7E,iBAA6E;IAA7E,iBAA6E;IAA7E,wBAA6E;IAA7E,oBAA6E;IAA7E;AAA6E;AAA7E;IAAA;QAAA,mBAA6E;QAA7E;IAA6E;AAAA;;AAGjF,gBAAgB;AAEZ;IAAA,eAA4F;IAA5F,UAA4F;IAA5F,WAA4F;IAA5F,+LAA4F;IAA5F,kBAA4F;IAA5F,qEAA4F;IAA5F,8BAA4F;IAA5F,wDAA4F;IAA5F,0BAA4F;IAA5F;AAA4F;;AAI5F;IAAA,uBAAwB;IAAxB;AAAwB;;AAIxB;IAAA,qBAAoB;IAApB;AAAoB;;AAGxB,qBAAqB;AAEjB;IAAA;QAAA;IAAuC;AAAA;AAAvC;IAAA,yDAAuC;IAAvC,kBAAuC;IAAvC;AAAuC;;AAG3C,wBAAwB;AACxB;IACI,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,iEAAiE;;AAEjE;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;IAC9C,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,oBAAoB;AACxB;;AAEA,0CAA0C,UAAU,EAAE;AACtD,gDAAgD,mBAAmB,EAAE;AACrE,gDAAgD,gBAAgB,EAAE,kBAAkB,EAAE;;AAEtF,0BAA0B,2BAA2B,EAAE,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC3G,0BAA0B,2BAA2B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC7G,0BAA0B,2BAA2B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC7G,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAClF,0BAA0B,mBAAmB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACrF,0BAA0B,gBAAgB,EAAE;AAC5C,kCAAkC,8BAA8B,EAAE,aAAa,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE;AAC3J,yBAAyB,cAAc,EAAE,0BAA0B,EAAE;AACrE,2BAA2B,eAAe,EAAE,YAAY,EAAE,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE,sCAAsC,EAAE;AACrJ,0BAA0B,YAAY,EAAE,6BAA6B,EAAE,eAAe,EAAE;AACxF,sDAAsD,iBAAiB,EAAE;AACzE,kDAAkD,kBAAkB,EAAE;AACtE,yBAAyB,0BAA0B,EAAE;AACrD,yBAAyB,6BAA6B,EAAE;;AAExD,6EAA6E;;AAE7E;IACI,8CAA8C;IAC9C,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,8CAA8C;IAC9C,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,8CAA8C;IAC9C,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;AAC1B;AACA,gCAAgC,cAAc,EAAE;;AAEhD;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;0BAC0B,iBAAiB,EAAE;;AAE7C;0BAC0B,kBAAkB,EAAE;;AAE9C,0BAA0B,0BAA0B,EAAE,0BAA0B,EAAE;;AAElF,0BAA0B,6BAA6B,EAAE;;AAEzD;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,mFAAmF;;AAEnF;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,sDAAsD,mBAAmB,EAAE;AAC3E,sDAAsD,mBAAmB,EAAE;;AAE3E;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;IAGI,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":["/* App-specific styles for Le Saverdunois */\r\n\r\n/* Navigation styles */\r\n.nav-link {\r\n    @apply font-sans uppercase text-sm font-medium tracking-wide text-saverdun-text hover:text-saverdun-primary transition-colors;\r\n}\r\n\r\n.nav-link.active {\r\n    @apply text-saverdun-primary;\r\n}\r\n\r\n/* Editorial grid borders */\r\n.editorial-border-r {\r\n    @apply border-r border-saverdun-border;\r\n}\r\n\r\n.editorial-border-b {\r\n    @apply border-b border-saverdun-border;\r\n}\r\n\r\n.editorial-border-t {\r\n    @apply border-t border-saverdun-border;\r\n}\r\n\r\n/* Article card hover */\r\n.article-card {\r\n    @apply transition-all duration-300;\r\n}\r\n\r\n.article-card:hover {\r\n    @apply bg-saverdun-accent/30;\r\n}\r\n\r\n.article-card:hover .article-title {\r\n    @apply text-saverdun-primary;\r\n}\r\n\r\n.article-card .article-image {\r\n    @apply transition-transform duration-500;\r\n}\r\n\r\n.article-card:hover .article-image {\r\n    @apply scale-105;\r\n}\r\n\r\n/* Category badges */\r\n.category-badge {\r\n    @apply font-mono text-xs uppercase tracking-[0.2em] text-saverdun-primary;\r\n}\r\n\r\n/* Button styles */\r\n.btn-primary {\r\n    @apply bg-saverdun-primary text-white hover:bg-saverdun-primary-hover px-6 py-3 font-sans font-medium transition-colors;\r\n}\r\n\r\n.btn-secondary {\r\n    @apply border border-saverdun-text text-saverdun-text hover:bg-saverdun-inverse hover:text-white px-6 py-3 transition-colors;\r\n}\r\n\r\n/* Newsletter section */\r\n.newsletter-section {\r\n    @apply bg-saverdun-inverse text-white;\r\n}\r\n\r\n/* Calendar event item */\r\n.event-item {\r\n    @apply border-l-4 border-saverdun-primary pl-4 py-2;\r\n}\r\n\r\n/* Admin panel styles */\r\n.admin-sidebar {\r\n    @apply bg-saverdun-inverse text-white min-h-screen;\r\n}\r\n\r\n.admin-nav-item {\r\n    @apply px-4 py-3 hover:bg-white/10 transition-colors cursor-pointer;\r\n}\r\n\r\n.admin-nav-item.active {\r\n    @apply bg-saverdun-primary;\r\n}\r\n\r\n/* Form styles */\r\n.form-input {\r\n    @apply w-full border border-saverdun-border bg-saverdun-surface px-4 py-3 font-sans text-saverdun-text focus:outline-none focus:border-saverdun-primary transition-colors;\r\n}\r\n\r\n.form-textarea {\r\n    @apply w-full border border-saverdun-border bg-saverdun-surface px-4 py-3 font-sans text-saverdun-text focus:outline-none focus:border-saverdun-primary transition-colors resize-none;\r\n}\r\n\r\n.form-label {\r\n    @apply block font-sans text-sm font-medium text-saverdun-text mb-2;\r\n}\r\n\r\n/* Page header */\r\n.page-header {\r\n    @apply py-12 border-b border-saverdun-border;\r\n}\r\n\r\n.page-title {\r\n    @apply font-serif text-4xl sm:text-5xl tracking-tight text-saverdun-text;\r\n}\r\n\r\n/* Section styles */\r\n.section-title {\r\n    @apply font-serif text-2xl sm:text-3xl tracking-tight text-saverdun-text mb-6;\r\n}\r\n\r\n/* Mobile menu */\r\n.mobile-menu {\r\n    @apply fixed inset-0 bg-saverdun-background z-50 transform transition-transform duration-300;\r\n}\r\n\r\n.mobile-menu.closed {\r\n    @apply -translate-x-full;\r\n}\r\n\r\n.mobile-menu.open {\r\n    @apply translate-x-0;\r\n}\r\n\r\n/* Loading skeleton */\r\n.skeleton {\r\n    @apply bg-saverdun-border animate-pulse;\r\n}\r\n\r\n/* Toast customization */\r\n[data-sonner-toaster] {\r\n    --normal-bg: #111111;\r\n    --normal-text: #ffffff;\r\n    --success-bg: #111111;\r\n    --success-text: #ffffff;\r\n    --error-bg: #D92D20;\r\n    --error-text: #ffffff;\r\n}\r\n\r\n/* ===================== RICH TEXT EDITOR ===================== */\r\n\r\n.rich-editor-wrapper {\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.08);\r\n}\r\n\r\n.rich-editor-wrapper:focus-within {\r\n    box-shadow: 0 0 0 2px rgba(217, 45, 32, 0.25);\r\n}\r\n\r\n.rich-editor-toolbar {\r\n    background: #f8f8f7;\r\n    border-bottom: 1px solid #e8e4dc;\r\n    padding: 8px 10px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 2px;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 10;\r\n}\r\n\r\n.rich-editor-content {\r\n    min-height: 300px;\r\n    max-height: 600px;\r\n    overflow-y: auto;\r\n    padding: 20px 24px;\r\n    font-family: Georgia, 'Times New Roman', serif;\r\n    font-size: 1rem;\r\n    line-height: 1.75;\r\n    color: #1a1a1a;\r\n    background: #fff;\r\n    outline: none;\r\n    caret-color: #D92D20;\r\n}\r\n\r\n.rich-editor-content::-webkit-scrollbar { width: 6px; }\r\n.rich-editor-content::-webkit-scrollbar-track { background: #f1f1f1; }\r\n.rich-editor-content::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }\r\n\r\n.rich-editor-content h1 { font-family: Georgia, serif; font-size: 2em; font-weight: bold; margin: 0.5em 0; }\r\n.rich-editor-content h2 { font-family: Georgia, serif; font-size: 1.6em; font-weight: bold; margin: 0.5em 0; }\r\n.rich-editor-content h3 { font-family: Georgia, serif; font-size: 1.3em; font-weight: bold; margin: 0.5em 0; }\r\n.rich-editor-content p  { margin: 0.5em 0; }\r\n.rich-editor-content ul { list-style: disc; padding-left: 1.8em; margin: 0.5em 0; }\r\n.rich-editor-content ol { list-style: decimal; padding-left: 1.8em; margin: 0.5em 0; }\r\n.rich-editor-content li { margin: 0.25em 0; }\r\n.rich-editor-content blockquote { border-left: 4px solid #D92D20; margin: 1em 0; padding: 0.5em 1em; background: #fdf6f0; font-style: italic; color: #555; }\r\n.rich-editor-content a { color: #D92D20; text-decoration: underline; }\r\n.rich-editor-content img { max-width: 100%; height: auto; margin: 8px 0; display: block; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.12); }\r\n.rich-editor-content hr { border: none; border-top: 2px solid #e8e4dc; margin: 1.5em 0; }\r\n.rich-editor-content strong, .rich-editor-content b { font-weight: bold; }\r\n.rich-editor-content em, .rich-editor-content i { font-style: italic; }\r\n.rich-editor-content u { text-decoration: underline; }\r\n.rich-editor-content s { text-decoration: line-through; }\r\n\r\n/* ===================== ARTICLE RICH CONTENT DISPLAY ===================== */\r\n\r\n.article-rich-content h1 {\r\n    font-family: Georgia, 'Times New Roman', serif;\r\n    font-size: 2.2em;\r\n    font-weight: bold;\r\n    line-height: 1.2;\r\n    margin: 1.2em 0 0.5em;\r\n    color: #1a1a1a;\r\n}\r\n\r\n.article-rich-content h2 {\r\n    font-family: Georgia, 'Times New Roman', serif;\r\n    font-size: 1.7em;\r\n    font-weight: bold;\r\n    line-height: 1.3;\r\n    margin: 1.1em 0 0.5em;\r\n    color: #1a1a1a;\r\n    border-bottom: 2px solid #e8e4dc;\r\n    padding-bottom: 0.3em;\r\n}\r\n\r\n.article-rich-content h3 {\r\n    font-family: Georgia, 'Times New Roman', serif;\r\n    font-size: 1.3em;\r\n    font-weight: bold;\r\n    margin: 1em 0 0.4em;\r\n    color: #2a2a2a;\r\n}\r\n\r\n.article-rich-content p {\r\n    margin: 0.9em 0;\r\n    line-height: 1.85;\r\n}\r\n\r\n.article-rich-content ul {\r\n    list-style: disc;\r\n    padding-left: 2em;\r\n    margin: 0.8em 0;\r\n}\r\n\r\n.article-rich-content ol {\r\n    list-style: decimal;\r\n    padding-left: 2em;\r\n    margin: 0.8em 0;\r\n}\r\n\r\n.article-rich-content li {\r\n    margin: 0.35em 0;\r\n    line-height: 1.7;\r\n}\r\n\r\n.article-rich-content blockquote {\r\n    border-left: 4px solid #D92D20;\r\n    margin: 1.5em 0;\r\n    padding: 1em 1.5em;\r\n    background: #fdf6f0;\r\n    font-style: italic;\r\n    color: #555;\r\n    border-radius: 0 6px 6px 0;\r\n    font-size: 1.08em;\r\n}\r\n\r\n.article-rich-content a {\r\n    color: #D92D20;\r\n    text-decoration: underline;\r\n    text-underline-offset: 2px;\r\n    transition: color 0.2s;\r\n}\r\n.article-rich-content a:hover { color: #b02318; }\r\n\r\n.article-rich-content img {\r\n    max-width: 100%;\r\n    height: auto;\r\n    display: block;\r\n    margin: 1.5em auto;\r\n    border-radius: 6px;\r\n    box-shadow: 0 4px 16px rgba(0,0,0,0.14);\r\n}\r\n\r\n.article-rich-content hr {\r\n    border: none;\r\n    border-top: 2px solid #e8e4dc;\r\n    margin: 2em 0;\r\n}\r\n\r\n.article-rich-content strong,\r\n.article-rich-content b { font-weight: bold; }\r\n\r\n.article-rich-content em,\r\n.article-rich-content i { font-style: italic; }\r\n\r\n.article-rich-content u { text-decoration: underline; text-underline-offset: 2px; }\r\n\r\n.article-rich-content s { text-decoration: line-through; }\r\n\r\n.article-rich-content pre,\r\n.article-rich-content code {\r\n    background: #f4f4f0;\r\n    border-radius: 4px;\r\n    padding: 0.2em 0.4em;\r\n    font-family: monospace;\r\n    font-size: 0.9em;\r\n}\r\n\r\n/* ===================== DARK MODE OVERRIDES (rich content) ===================== */\r\n\r\n.dark .rich-editor-toolbar {\r\n    background: #232019;\r\n    border-bottom-color: #3a362f;\r\n}\r\n\r\n.dark .rich-editor-content {\r\n    color: #f2ede6;\r\n    background: #201d19;\r\n}\r\n\r\n.dark .rich-editor-content::-webkit-scrollbar-track { background: #2a2620; }\r\n.dark .rich-editor-content::-webkit-scrollbar-thumb { background: #4a453c; }\r\n\r\n.dark .rich-editor-content blockquote,\r\n.dark .article-rich-content blockquote {\r\n    background: #2a221c;\r\n    color: #c9c2b6;\r\n}\r\n\r\n.dark .rich-editor-content hr,\r\n.dark .article-rich-content hr {\r\n    border-top-color: #3a362f;\r\n}\r\n\r\n.dark .article-rich-content h1,\r\n.dark .article-rich-content h2,\r\n.dark .article-rich-content h3 {\r\n    color: #f2ede6;\r\n}\r\n\r\n.dark .article-rich-content h2 {\r\n    border-bottom-color: #3a362f;\r\n}\r\n\r\n.dark .rich-editor-content pre,\r\n.dark .article-rich-content pre,\r\n.dark .article-rich-content code {\r\n    background: #2a2620;\r\n    color: #f2ede6;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
